import { render, staticRenderFns } from "./DetailDrink.vue?vue&type=template&id=5f3e3a90&scoped=true&"
import script from "./DetailDrink.vue?vue&type=script&lang=js&"
export * from "./DetailDrink.vue?vue&type=script&lang=js&"
import style0 from "./DetailDrink.vue?vue&type=style&index=0&id=5f3e3a90&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e3a90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MediaThumb: require('/opt/build/repo/components/MediaThumb.vue').default,ButtonBlob: require('/opt/build/repo/components/ButtonComponents/ButtonBlob.vue').default})
